exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar-customized{background-color:#f1f2f8;padding:40px 0;min-height:calc(100vh - 56px)}.calendar-customized .heading-2{font-size:25px}@media (min-width:768px){.calendar-customized{padding:80px 0 60px}}@media (min-width:960px){.calendar-customized{min-height:calc(100vh - 64px)}}@media (min-width:1024px){.calendar-customized{padding:80px 0 100px}.calendar-customized .heading-2{font-size:35px}}@media (min-width:1366px){.calendar-customized{padding:0}}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};